<template>
  <div class="col-12">
    <div class="accordion">
      <b-card no-body class="mb-1" v-b-toggle="`accordion-${index+2}`" @click="setIsOpen">
        <b-card-header header-tag="header" role="tab">
          <div class="row">
            <div class="col-1 accordion__title">
              <b-icon
                  :flip-v="!isOpen"
                  icon="arrow-down-short"
                  variant="dark"
              >
              </b-icon>
              <strong><img :src="require(`@/assets/flags/${content.lang ? content.lang.toLowerCase() : content.locale.toLowerCase()}.svg`)" class="table-flags mr-1">{{ content.lang ? content.lang.toUpperCase() : content.locale.toUpperCase() }}</strong>
            </div>
            <div class="col-9 text-right"  style="z-index: 2;">
              <b-form-group >
              <b-form-checkbox v-if="correct"
                  :id="'checkbox-'+index"
                  :name="'checkbox-'+index"
                  v-model="data.toBeVerified"
                  :value="true"
                  :unchecked-value="false"
              >
                {{ $t('checkbox.correct_question') }}
              </b-form-checkbox>
              </b-form-group>
            </div>
            <div class="col-2 text-right">
              <button class="btn btn-xs btn-danger delete-translation-btn" @click="removeTranslation">{{ $t('btn.delete_translation') }}</button>
            </div>
          </div>
        </b-card-header>
        <b-collapse :id="`accordion-${index}`" :visible="isOpen" accordion="my-accordion" role="tabpanel" class="p-4">
          <div class="row" @click="stopEventBubbling">
            <div class="col-6">
              <b-form-group
                  :label="$t('btn.question_content')">
                <b-form-textarea
                    v-model="data.question"
                    v-on:keydown.space.stop
                    @input="$v.data.question.$model = $event"
                    :state="!$v.data.question.$dirty ? null : !$v.data.question.$error"
                    rows="9"
                    max-rows="9"
                    :placeholder="$t('validate.max.256')">
                </b-form-textarea>
              </b-form-group>
            </div>
            <div class="col-6">
              <b-form-group :label="$t('form.label.answers')">
                <div class="d-flex align-items-center mb-3">
                  <span class="mr-2">1.</span>
                  <b-form-input
                      v-model="data.answers[0]"
                      v-on:keydown.space.stop
                      @input="$v.data.answers.$each[0].$model = $event;"
                      :state="!$v.data.answers.$each[0].$dirty ? null : !$v.data.answers.$each[0].$error"
                      :placeholder="$t('validate.max.256')">>
                  </b-form-input>
                </div>
                <div class="d-flex align-items-center mb-3">
                  <span class="mr-2">2.</span>
                  <b-form-input
                      v-model="data.answers[1]"
                      v-on:keydown.space.stop
                      @input="$v.data.answers.$each[1].$model = $event"
                      :state="!$v.data.answers.$each[1].$dirty ? null : !$v.data.answers.$each[1].$error"
                      :placeholder="$t('validate.max.256')">>
                  </b-form-input>
                </div>
                <div class="d-flex align-items-center mb-3">
                  <span class="mr-2">3.</span>
                  <b-input
                      v-model="data.answers[2]"
                      v-on:keydown.space.stop
                      @input="$v.data.answers.$each[2].$model = $event"
                      :state="!$v.data.answers.$each[2].$dirty ? null : !$v.data.answers.$each[2].$error"
                      :placeholder="$t('validate.max.256')">>
                  </b-input>
                </div>
                <div class="d-flex align-items-center mb-3">
                  <span class="mr-2">4.</span>
                  <b-input
                      v-model="data.answers[3]"
                      v-on:keydown.space.stop
                      @input="$v.data.answers.$each[3].$model = $event"
                      :state="!$v.data.answers.$each[3].$dirty ? null : !$v.data.answers.$each[3].$error"
                      :placeholder="$t('validate.max.256')">>
                  </b-input>
                </div>
              </b-form-group>
            </div>
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import {required, maxLength} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";

export default {
  components: {},
  props: ['content', 'index', 'correct'],
  mixins: [validationMixin],
  validations: {
    data: {
      question: {
        required,
        maxLength: maxLength(120)
      },
      answers: {
        required,
        $each: {
          required,
          maxLength: maxLength(55)
        }
      }
    },
  },
  data() {
    return {
      data: {
        id: null,
        locale: null,
        question: null,
        answers: ['','','','']
      },
      errors: {
        answer: 'Answer is a required field!'
      },
      isOpen: false
    }
  },
  mounted() {
    this.data.id = this.content.id;
    this.data.locale = this.content.locale;
    this.data.question = this.content.question;

    if (this.correct) {
      this.data.toBeVerified = false;
      this.isOpen = this.correct === this.data.locale;
    }

    if(this.content && this.content.answers) {
      this.data.answers.splice(0, 1, this.content.answers[1]);
      this.data.answers.splice(1, 1, this.content.answers[2]);
      this.data.answers.splice(2, 1, this.content.answers[3]);
      this.data.answers.splice(3, 1, this.content.answers[4]);
    }
  },
  methods: {
    stopEventBubbling(e) {
      e.stopPropagation();
    },
    getData() {
      if (this.data.toBeVerified) {
        return {
          id: this.content.id,
          locale: this.content.lang ? this.content.lang : this.content.locale,
          content: this.data.question,
          answer1: this.data.answers[0],
          answer2: this.data.answers[1],
          answer3: this.data.answers[2],
          answer4: this.data.answers[3],
          toBeVerified: this.data.toBeVerified
        }
      } else {
        return {
          id: this.content.id,
          locale: this.content.lang ? this.content.lang : this.content.locale,
          content: this.data.question,
          answer1: this.data.answers[0],
          answer2: this.data.answers[1],
          answer3: this.data.answers[2],
          answer4: this.data.answers[3]
        }
      }
    },
    setIsOpen() {
      this.isOpen = !this.isOpen;
    },
    removeTranslation() {
      this.$emit('remove-translation')
    },
    validateState(entry) {
      if (entry.constructor.name === 'Array') {
        switch (entry.length) {
          case 3:
            entry = this.$v.data[entry[0]][entry[1]][entry[2]];
            break;
          case 2:
            entry = this.$v.data[entry[0]][entry[1]];
            break;
        }
      } else {
        entry = this.$v.data[entry];
      }

      const {$dirty, $error} = entry;
      return $dirty ? !$error : null;
    },
    touch() {
      this.$v.$touch();
      this.$emit('translation-is-invalid', this.$v.$invalid);
    },
    resetForm() {

    }
  }
}
</script>
